import { AnyAction } from 'redux'

import { IAccountState } from 'models/account.model'

import {
  RESET_EMAIL_ERROR_MESSAGE,
  RESET_PASSWORD_ERROR_MESSAGE,
  SET_ACCOUNT_STATUS,
  SET_EMAIL_ERROR_MESSAGE,
} from './actions'

const initialState: IAccountState = {
  emailErrorMessage: null,
  passwordErrorMessage: null,
  accountStatus: {
    existingUuid: '',
    hasAccessToApp: false,
    hasAccount: null,
  },
}

export function accountReducer(
  state = initialState,
  { type, payload }: AnyAction,
): IAccountState {
  switch (type) {
    case SET_EMAIL_ERROR_MESSAGE: {
      return { ...state, emailErrorMessage: payload }
    }
    case RESET_EMAIL_ERROR_MESSAGE: {
      return { ...state, emailErrorMessage: null }
    }
    case RESET_PASSWORD_ERROR_MESSAGE: {
      return { ...state, passwordErrorMessage: null }
    }
    case SET_ACCOUNT_STATUS: {
      return {
        ...state,
        accountStatus: {
          existingUuid: payload.existingUuid,
          hasAccount: payload.hasAccount,
          hasAccessToApp: payload.hasAccessToApp,
        },
      }
    }

    default:
      return state
  }
}
